<template>
	<div class="container">
		<div class="section">
			<div class="profile_page">
				<b-overlay :show="isLoading">
					<h1 class="text-xs-center">Регистрация</h1>
					<BaseUid :user="user" ref="baseUid"/>
					<BasePassword :user="user" ref="basePassword"/>
					<b-form-group label="Email:">
						<b-form-input v-model="$v.user.email.$model" placeholder="Введите email" :state="validateUser('email')" autocomplete="off"></b-form-input>
						<b-form-invalid-feedback v-if="!$v.user.email.required">Поле обязательно для заполнения</b-form-invalid-feedback>
						<b-form-invalid-feedback v-if="!$v.user.email.email">Некорректный адрес электронной почты</b-form-invalid-feedback>
					</b-form-group>
					<b-form-group label="Фамилия:">
						<b-form-input v-model="$v.user.lastName.$model" placeholder="Введите фамилию" :state="validateUser('lastName')" autocomplete="off"></b-form-input>
						<b-form-invalid-feedback style="white-space: pre-wrap;">Поле обязательно для заполнения</b-form-invalid-feedback>
					</b-form-group>
					<b-form-group label="Имя:">
						<b-form-input v-model="$v.user.firstName.$model" placeholder="Введите имя" :state="validateUser('firstName')" autocomplete="off"></b-form-input>
						<b-form-invalid-feedback style="white-space: pre-wrap;">Поле обязательно для заполнения</b-form-invalid-feedback>
					</b-form-group>
					<b-form-group label="Отчество:">
						<b-form-input v-model="user.middleName" autocomplete="off"></b-form-input>
					</b-form-group>
					<b-form-group label="Организация:">
						<b-form-input v-model="user.organization" autocomplete="off"></b-form-input>
					</b-form-group>
					<b-form-group label="Должность:">
						<b-form-input v-model="user.position" autocomplete="off"></b-form-input>
					</b-form-group>
					<b-form-group>
						<vue-recaptcha v-bind:sitekey="recaptcha.key" @verify="recaptchaVerify" @expired="recaptchaExpired" ref="recaptcha_box"></vue-recaptcha>
					</b-form-group>
					<b-form-group>
						<div v-if="error" class="error">
							<h5>{{ error }}</h5>
						</div>
					</b-form-group>
					<b-form-group>
						<div>Нажимая кнопку "Зарегистрировать", Вы принимаете условия <a v-bind:href="privacy_policy_url" target="_blank">Политики конфиденциальности</a></div>
					</b-form-group>
					<b-form-group v-if="errors.length > 0">
						<div class="error" v-for="(error, index) in errors" :key="index">{{ error }}</div>
					</b-form-group>
					<b-button variant="primary" v-on:click="save" onclick="this.blur();" style="float: right;">Зарегистрировать</b-button>
				</b-overlay>
			</div>
		</div>
		<div class="section section_features">
			<div class="content_features">
				<div class="reg_title_h">Зачем создавать учетную запись?</div>
				<div class="reg_feature">
					<div class="f_img f_img_1"></div>
					<div class="f_about">Ваши данные хранятся на сервере</div>
				</div>
				<div class="reg_feature">
					<div class="f_img f_img_2"></div>
					<div class="f_about">Управляйте своими закладками</div>
				</div>
				<div class="reg_feature">
					<div class="f_img f_img_3"></div>
					<div class="f_about">Сохраняйте и храните свои геоданные (точки, маршруты, треки)</div>
				</div>
				<div class="reg_feature">
					<div class="f_img f_img_4"></div>
					<div class="f_about">Удалённое редактирование пространственных данных</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { REGISTER, REGISTER_RESET } from '@/store/actions.type'
import VueRecaptcha from 'vue-recaptcha'
import { required, email } from 'vuelidate/lib/validators'
import BaseUid from '@/components/views/Manager/Shared/BaseUid'
import BasePassword from '@/components/views/Manager/Shared/BasePassword'

export default {
	name: 'Register',
	validations: {
		user: {
			firstName: {
				required
			},
			lastName: {
				required
			},
			email: {
				required,
				email
			}
		}
	},
	data () {
		return {
			user : {
				uid: '',
				firstName: '',
				lastName: '',
				email: '',
				password: '',
				password_confirm: '',
				middleName: '',
				organization: '',
				position: ''
			},
			recaptcha: {
				response: '',
				key: process.env.RECAPTCHA_KEY
			},
			success: false,
			error: '',
			privacy_policy_url: process.env.PRIVACY_POLICY_URL
		}
	},
	created () {
		this.$store.dispatch(REGISTER_RESET)
	},
	components: {
		VueRecaptcha,
		BaseUid,
		BasePassword
	},
	computed: {
		...mapGetters({
			isLoading: 'registerIsLoading',
			errors: 'registerErrors'
		})
	},
	methods: {
		recaptchaVerify (response) {
			this.recaptcha.response = response
		},
		recaptchaExpired () {
			this.recaptcha.response = ''
		},
		save () {
			this.$v.user.$touch()
			this.$refs.basePassword.$v.user.$touch()
			this.$refs.baseUid.$v.user.$touch()
			if (this.$v.user.$anyError || this.$refs.basePassword.$v.user.$anyError || this.$refs.baseUid.$v.user.$anyError || !(this.recaptcha.response && this.recaptcha.response.length > 0)) {
				this.$refs.recaptcha_box.reset()
				this.recaptcha.response = ''
				return
			}

			this.$store.dispatch(REGISTER, {
				uid: this.user.uid,
				email: this.user.email,
				password: this.user.password,
				firstName: this.user.firstName,
				lastName: this.user.lastName,
				key: this.recaptcha.response,
				middleName: this.user.middleName,
				organization: this.user.organization,
				position: this.user.position
			})
			.then((data) => {
				this.success = data === true ? true : false
				if (this.success) {
					this.error = ''
					this.$router.push({ name: 'register_success' })
				}
				else {
					this.error = "Не удалось создать пользователя"
				}	
			})

			this.$refs.recaptcha_box.reset()
			this.recaptcha.response = ''
		},
		validateUser(name) {
			const { $dirty, $error } = this.$v.user[name]
			return $dirty ? !$error : null
		}
	}
}
</script>

<style scoped>
.section_features {
	margin-top: 50px;
	height: auto;
}
.content_features {
	height: auto;
	display: flex;
	flex-wrap: wrap;
	align-items: stretch;
}
.reg_title {
	width: 100%;
	height: 80px;
	font-weight: 600;
	font-size: 2.5rem;
	margin-top: 40px;
	padding: 10px;
	text-align:center;
}
.reg_title_h {
	font-size: 2rem;
	font-weight: 100;
	width: 100%;
	text-align: center;
	height: 60px;
}
.reg_feature {
	width:25%;
	text-align: center;
	padding: 10px;
}
.f_img {
	height: 70px;
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
}
.f_img_1 {
	background-image: url("~@/assets/f_img_1.png");
}
.f_img_2 {
	background-image: url("~@/assets/f_img_2.png");
}
.f_img_3 {
	background-image: url("~@/assets/f_img_3.png");
}
.f_img_4 {
	background-image: url("~@/assets/f_img_4.png");
}
.f_about {
	height: 100px;
	margin-top: 20px;
}

@media only screen and (max-width: 420px) {
	.reg_feature {
		width: 100%;
	}
	.reg_title_h {
		font-size: 2rem;
	}
}
@media only screen and (min-width: 421px) and (max-width: 960px) {
	.reg_feature {
		width: 50%;
	}
}

</style>


// WEBPACK FOOTER //
// src/components/views/Register/Register.vue